<template>
    <span v-if="rentalExpenseID">
        <b-button
            class="align-baseline mr-1"
            title="Edit"
            variant="default"
            @click="handleEditRentalExpense"
        >
            <font-awesome-icon :icon="['fas', 'pen-to-square']"></font-awesome-icon>
        </b-button>
        <b-button
            class="align-baseline"
            title="Delete"
            variant="default"
            v-b-modal="deleteModalID"
        >
            <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
        </b-button>
        <modal
            :id="deleteModalID"
            title="Delete Rental Expense"
            @shown="onModalShown"
            :hide-footer="params.data.has_published_owner_statement"
            @ok="handleDeleteRentalExpense"
        >
            <b-alert variant="danger" :show="params.data.has_published_owner_statement">
                This rental expense has already been reconciled to a published owner statement and cannot be deleted.
            </b-alert>
            <template v-if="!params.data.has_published_owner_statement"
                >Are you sure you want to delete rental expense #{{ rentalExpenseID }}?</template
            >
        </modal>
    </span>
</template>

<script>
    import { mapGetters } from 'vuex';
    import API from '../../../api';
    import Modal from '../../generic/modal/modal.vue';

    export default {
        components: {
            Modal,
        },
        data() {
            return {
                rentalExpenseID: 0,
                deleteModalID: '',
            };
        },
        created() {
            this.rentalExpenseID = this.params.data && this.params.data.id;
            this.deleteModalID = `modal-delete-rental-expense-${this.rentalExpenseID}`;
        },
        methods: {
            onModalShown() {
                this.params.api.clearFocusedCell();
            },
            handleEditRentalExpense() {
                this.params.update && this.params.update(this.params.data);
            },
            handleDeleteRentalExpense() {
                this.params.delete && this.params.delete(this.params.data);
            },
        },
    }
</script>
